import React from 'react';
import PropTypes from 'prop-types';

// Components
import InfoPanel from './InfoPanel';

// Constants
import { T } from '../constants/tokens';

export default function DefaultInfoPanel({ style, message = 'Select a card to see its details.' }) {
  return (
    <InfoPanel style={style}>
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: 24,
          fontSize: 14,
          lineHeight: '20px',
          color: T.muted
        }}
      >
        {message}
      </div>
    </InfoPanel>
  );
}

DefaultInfoPanel.propTypes = {
  style: PropTypes.object,
  message: PropTypes.string
};
